import React from 'react';

interface IProps {
  email: string;
  loginError?: string;
  onReturningUserSubmit: (email: string, password: string) => void;
}

interface IState {
  email: string;
  password?: string;
}

export default class ReturningUserForm extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = { email: props.email };
  }

  public render() {
    const { email, loginError } = this.props;

    return (
      <form onSubmit={this.onSubmit}>
        <h1 className="login-header">Welcome back</h1>
        <div className="input-section text-left">
          <p className="input-field">
            <b>Email address</b>
            <br />
            <span>{email}</span>
          </p>
          <p className="input-field">
            <b>Password</b>
            <br />
            <input
              type="password"
              placeholder="Password"
              onChange={this.handleChangePassword}
              required={true}
            />
          </p>
          {loginError && <p className="text-red">Invalid credentials</p>}
          <button className="button primary submit-button">
            {/* TODO: loading spinner? disable button if request is in progress? (prevent double-submit) */}
            Sign in
          </button>
          <p className="text-small text-center">
            <a href="/reset-password/new" target="_self">
              Forgot password?
            </a>
          </p>
        </div>
      </form>
    );
  }

  private handleChangePassword = e => {
    this.setState({ password: e.target.value });
  };

  private onSubmit = e => {
    e.preventDefault();
    const { email, password } = this.state;
    this.props.onReturningUserSubmit(email, password);
  };
}
